import React, { FormEvent, useState, useEffect } from 'react';
import { Typography, makeStyles, Grid, Button, InputLabel, Theme } from '@material-ui/core';
import { useAppState } from '../../../state';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: { marginBottom: '1em' },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': { marginRight: '1em' },
    [theme.breakpoints.down('sm')]: { margin: '1.5em 0 2em' },
  },
  textFieldContainer: { width: '100%' },
  continueButton: {
    [theme.breakpoints.down('sm')]: { width: '100%' },
  },
  Room: { fontSize: '20px', marginTop: '10px', color: '#333', fontWeight: 500 },
}));

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  setName: (name: string) => void;
  setRoomName: (roomName: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({ name, roomName, setName, setRoomName, handleSubmit }: RoomNameScreenProps) {
  const classes = useStyles();
  const { user } = useAppState();

  // 1. Estado de bloqueo
  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    // EL ESCÁNER: Revisa la memoria constantemente para atrapar el cambio de P2
    const checkStorage = () => {
      const ended = window.sessionStorage.getItem('meeting_ended') === 'true';

      if (ended && !isBlocked) {
        console.log('DEBUG [Lobby]: Reunión terminada detectada. Bloqueando...');
        setIsBlocked(true);
        // Borramos la marca de la MEMORIA inmediatamente, pero el BOTÓN
        // se queda gris gracias al estado isBlocked de React.
        window.sessionStorage.removeItem('meeting_ended');
      }
    };

    // Revisar cada 100ms para que sea instantáneo para el Participante 2
    const interval = setInterval(checkStorage, 100);

    // Limpieza al desmontar
    return () => clearInterval(interval);
  }, [isBlocked]);

  const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Join a Room
      </Typography>
      <Typography variant="body1">
        {hasUsername ? "Enter the name of a room you'd like to join." : 'Enter your name and the name of a room'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          {/* Nombre y Sala: SOLO LABELS (No editables) */}
          <div className={classes.textFieldContainer}>
            <InputLabel shrink>Your Name</InputLabel>
            <Typography className={classes.Room}>{name || user?.displayName || '---'}</Typography>
          </div>
          <div className={classes.textFieldContainer}>
            <InputLabel shrink>Room Name</InputLabel>
            <Typography className={classes.Room}>{roomName || '---'}</Typography>
          </div>
        </div>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            // Se bloquea si falta info o si la reunión terminó
            disabled={(!name && !user?.displayName) || !roomName || isBlocked}
            className={classes.continueButton}
          >
            {isBlocked ? 'Meeting Ended' : 'Continue'}
          </Button>
        </Grid>
      </form>
    </>
  );
}
